export const calculateScoreAndIndexes = (
  AnswerNames = [],
  OptionNames = [],
  userOrder = []
) => {
  if (
    !Array.isArray(AnswerNames) ||
    !Array.isArray(OptionNames) ||
    !Array.isArray(userOrder) ||
    userOrder.length === 0
  ) {
    return { userIndexes: [], correctIndexes: [], score: 0 };
  }

  const correctOrderIndexes = AnswerNames.map(
    (answer) => OptionNames.indexOf(answer)
  );
  const correctPairs = new Set(
    correctOrderIndexes
      .slice(0, -1)
      .map((_, index) => `${correctOrderIndexes[index]}-${correctOrderIndexes[index + 1]}`)
  );
  let score = 0;

  for (let index = 0; index < userOrder.length - 1; index += 1) {
    if (correctPairs.has(`${userOrder[index]}-${userOrder[index + 1]}`)) {
      score += 1;
    }
  }

  return {
    userIndexes: userOrder,
    correctIndexes: correctOrderIndexes,
    score,
  };
};

export const normalizeReorderParagraphResult = (submissionResult = {}) => {
  const result = submissionResult || {};
  const score = Number(result.score);

  return {
    userIndexes: Array.isArray(result.userIndexes)
      ? result.userIndexes.map(Number)
      : [],
    correctIndexes: Array.isArray(result.correctIndexes)
      ? result.correctIndexes.map(Number)
      : [],
    score: Number.isFinite(score) ? score : 0,
  };
};
